<template>
  <div class="page">
    <mu-toast v-if="toast" v-bind:message="hintMsg" @close="hideToast" id="alertline" />
    <mu-refresh-control :refreshing="refreshing" :trigger="trigger" @refresh="refresh" />
    <mu-appbar style="height: 1rem">
      <!--返回上一层-->
      <mu-icon value="keyboard_arrow_left" color="white" style="margin-top: 0.05rem" slot="left" v-on:click="goback()" />
      <div style="text-align:center; font-size:0.38rem;margin-top:">新闻列表</div>

      <mu-icon value="keyboard_arrow_left" color="#27ba69" style="margin-bottom: -0.05rem" slot="right" />

    </mu-appbar>

    <!--主页面-->
    <div style="background-color:#fff ; min-height:12.4rem"     >

      <mu-tabs :value="activeTab" @change="handleTabChange" style="width:100%">
        <mu-tab value="1" title="全部" />
        <mu-tab value="2" title="集团" />
        <mu-tab value="3" title="开业" />
        <mu-tab value="4" title="媒体" />
        <mu-tab value="5" title="社会" />
        <mu-tab value="6" title="游记" />
      </mu-tabs>
      <div style='height: 0.3rem;'></div>

      <!--这里是标签页的划分-->
      <div v-for='(ListName,index) in ["1","2","3","4","5","6"]' style="   ">

        <!--每页里面 ITEM的划分-->
        <div v-if="ListName == activeTab " v-on:click='LookDetail( item.ID  )' v-for='(item,index) in BreakfastList[activeTab]'>

          <div style="  width:6.9rem; margin:0  0.3rem; overflow:hidden ; border-bottom:1px solid #dddddd; height:1.6rem ; background-color:#fff;">

            <img v-bind:src="item.Pic" style="width:1.84rem; height:1.38rem; float:left; " />

            <div style='width: 0.3rem; height: 1.3rem; float:left;'> </div>

            <div style=' width: 4.5rem;  float:left;margin-top:-0.06rem '>
              <div style=" display: -webkit-box;  -webkit-line-clamp: 2  ;  -webkit-box-orient: vertical;  
                  overflow : hidden ;  font-size:0.3rem ; color:#333 ; height: 0.9rem  ">
                {{item.Title}}
              </div>
      <div style='height: 0.2rem;'></div>

              <div style=' font-size:0.22rem '>
                {{item.Create_Time}} |
                <span>
                  {{ item.ClassName }}
                </span>
              </div>
            </div>

          </div>

          <!--     <div style="      ">              </div>        -->
          <div style='height: 0.2rem;'></div>
        </div>
      </div>



      <loadListTail  mainTitle='此处无新闻' mainIcon='noInvoice' :noMore='loadState[this.activeTab].stop' :isLoading='loadState[this.activeTab].loading' :overZero='BreakfastList[activeTab].length > 0' />

      <div style="text-align:center;padding:0.2rem;" v-if='loadState[this.activeTab].loading'>
        <img src="../../../static/LoadingBest.gif" style=" width:1.2rem ;" />
      </div>
      <div style='height: 0.1rem;'></div>

    </div>

    <!--<div v-if='vo.Status == "0" && g_currentOrder.freeVoucherInfo.useNotSee' v-bind:class="{ 'active': vo.selected }" class='fBtn'></div>-->

  </div>
</template>





<script>
import api from '../../api'
import { mapGetters } from 'vuex'
import { mapMutations } from 'vuex'
import loadListTail from '../../components/loadListTail'
import Scroll from '../../utils/loading'
export default {
  data() {
    return {

      activeTab: '1',


      dialog: false,
      toast: false,

      BreakfastList: [[], [], [], [], [], [], [], []],


      loadState: [
        {
          loading: false,
          stop: false
        },
        {
          loading: false,
          stop: false
        },
        {
          loading: false,
          stop: false
        }
      ],
      hintMsg: '',
      pageSize: 10,
      refreshing: false,
      trigger: null,
      couponCode: '',
      scroll: null,



    }
  },
  activated() {

    // this.GetNewsFirstPage();

    this.scroll.addHandler()
    // if (!this.g_currentOrder.freeVoucherInfo.useNotSee && !this.loadState[this.activeTab].loaded) {
    //   this.initData()
    // }
  },
  mounted() {
    this.trigger = this.$el
    this.scroll = Scroll.Create(this, this.getData, this.pageSize, 7,1)
  },
  deactivated() {
    // this.getSelected()
    this.scroll.removeHandler()
  },
  components: {
    loadListTail
  },
  methods: {
    ...mapMutations(['setG_currentOrder'
    ]),
    initData() {

      //清空显示数据
      this.BreakfastList.splice(this.activeTab, 1, [])

      //初始化本页控制数据、分页参数
      this.scroll.refresh()
    },
    refresh() {
      this.refreshing = true
      setTimeout(() => {
        this.refreshing = false
        this.initData()
      }, 2000)
    },


    //新闻单页    (int newsType, int pageSize, int pageIndex)
    getData() {
      var Tab = this.activeTab

      var that = this
      var params = new this.URLSearchParam();
      params.append('pageIndex', this.pageParam[Tab].index);

      // if( Tab == 1 )   params.append('pageIndex', this.pageParam[Tab-1].index);

      params.append('pageSize', this.pageSize);
      params.append('newsType', Tab);
      //newsType  =  1 全部 23456 ~

      console.log( this.pageParam )

      return new Promise(function(resolve, reject) {
        that.$http.post(api.GetNewsList(), params.toParam()).then((res) => {
          if (res.Result) {
            var temp = res.Data

            if (temp == null) {
              resolve(null)
            }
            else {

              // that.initFreeVOuchers(temp)
              resolve(temp.length)
              that.BreakfastList[Tab] = that.BreakfastList[Tab].concat(temp)

            }
          }
          else {
            resolve(null)
            that.hintMsg = res.Message
            that.showToast()
          }
        })
      })

    },
    //三个分页
    handleTabChange(val) {

      this.activeTab = val;
      this.scroll.changeType(val)
    },

    // 跳转页面+传参
    LookDetail(IDCode) {

      this.$router.push({ path: '/Home/NewsDetailsPage?IDCode='+IDCode });
    },


    // 后退一页
    goback() {
      javascript: history.go(-1);
    },



    // 弹出层
    showToast() {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 1500)
      if (this.hintMsg == '请先登录') {
        console.log(this.hintMsg)
        this.$store.dispatch('clearUser');
        this.toastTimer = setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 1800)
      }
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },







  },
}
</script>







<style lang="less" scoped>
@import "../../assets/theme.less";

.mu-tabs {
  // 背景色
  background-color: #f5f5f5;
} // 未选中时候的颜色
.mu-tab-link {
  color: #999999;
  font-weight: bold;
} //  选中  分页的
.mu-tab-active {
  color: @primaryColor;
  font-weight: bold;
} // END 顶部标签变换
</style>







// WEBPACK FOOTER //
// NewsCenter.vue?3799e9e6